$(".enterFullScreen").click(function() {
  if ($(this).data("full") !== "yes") {
    launchIntoFullscreen(document.documentElement);
  }
  else {
    exitFullscreen();
  }
});


function launchIntoFullscreen(element)
{
  if (element.requestFullscreen) {
    element.requestFullscreen();
  }
  else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  }
  else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  }
  else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

function exitFullscreen()
{
  if (document.exitFullscreen) {
    document.exitFullscreen();
  }
  else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  }
  else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

/* stuff to do when moving to full screen */
var changeHandler = function() {

      if ($(this).data("full") !== "yes") {
        $(this).data("full", "yes");
        $(this).removeClass("fa-expand");
        $(this).addClass("fa-compress");
        // $("#canvasContainer").css("height", "100vh");
        // $("#charMsgBoxWrapper").css("height", "100vh");
        $("#fps").hide();
        $(".hideOnFullScreen").hide();
        if (typeof joysticks !== "undefined") {
          setTimeout(function() {
            joysticks.forEach(function(joystick) {
              joystick.resetStartAndEnd();
            });
          }, 1500);
        }
      }
      else {
        $(this).data("full", "no");
        $(this).addClass("fa-expand");
        $(this).removeClass("fa-compress");
        $(".hideOnFullScreen").show();
        setTimeout(function() {
            if (typeof joysticks !== "undefined") {
              joysticks.forEach(function(joystick) {
                joystick.resetStartAndEnd();
              });
            }
            // if (document.getElementById("charMsgBoxWrapper") !== null) {
            // document.getElementById("charMsgBoxWrapper").style.height = (window.innerHeight - 50) + 'px';
            // document.getElementById("canvasContainer").style.height   = (window.innerHeight - 50) + 'px';

            // }
          }
          ,
          1500
        );

      }
    }
;
if (document.getElementById("charMsgBoxWrapper") !== null && document.getElementById("canvasContainer") !== null) {
  document.getElementById("canvasContainer").style.height   = (window.innerHeight - 50) + 'px';
  // document.getElementById("charMsgBoxWrapper").style.height = (window.innerHeight - 50) + 'px';
}
document.addEventListener("fullscreenchange", changeHandler, false);
document.addEventListener("webkitfullscreenchange", changeHandler, false);
document.addEventListener("mozfullscreenchange", changeHandler, false);

